import {useEffect, useState} from 'react';
import type {Job} from '@cp/model';
import subscribeJobs from '../../api/jobs/subscribeJobs';

export default function useJobs() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    const unsub = subscribeJobs(
      (data: Job[]) => {
        setJobs(data);
        setLoading(false);
      },
      (err: Error) => {
        setError(err);
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  return {jobs, loading, error, refetch: () => {}};
}
